import type { ReactiveController, ReactiveControllerHost } from "lit";
import { pb, currentUser } from "./pb";
import type { TenancyUser } from "./types";

/**
 * Subscribes a Lit host to PocketBase auth-store changes (login, logout,
 * token refresh) so the host re-renders whenever the session changes.
 */
export class AuthController implements ReactiveController {
  private readonly host: ReactiveControllerHost;
  private unsubscribe?: () => void;

  constructor(host: ReactiveControllerHost) {
    this.host = host;
    host.addController(this);
  }

  hostConnected(): void {
    this.unsubscribe = pb.authStore.onChange(() => {
      this.host.requestUpdate();
    });
  }

  hostDisconnected(): void {
    this.unsubscribe?.();
    this.unsubscribe = undefined;
  }

  get isLoggedIn(): boolean {
    return pb.authStore.isValid;
  }

  get user(): TenancyUser | null {
    return currentUser();
  }

  hasRole(role: string): boolean {
    return this.user?.roles?.includes(role) ?? false;
  }
}
